import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'
import { getLocationCountry } from '@utils/geolocation'

interface UseGeolocationResult {
  countryCodeIso3: string | undefined
  isLoading: boolean
  isFailed: boolean
}

export const useGeolocation = (enabled: boolean = true): UseGeolocationResult => {
  const location = useLocation()
  const apiClient = useApiClient(ClientApiClient)
  const [countryCodeIso3, setCountryCodeIso3] = useState<string | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isFailed, setIsFailed] = useState<boolean>(false)

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false)
      return
    }

    const locationCountry = getLocationCountry(location)

    if (locationCountry) {
      setCountryCodeIso3(locationCountry.toUpperCase())
      setIsLoading(false)
      setIsFailed(false)
      return
    }

    setIsLoading(true)
    apiClient
      .getVisitorGeolocation()
      .then((d) => {
        setCountryCodeIso3(d.country_code_iso3)
        setIsFailed(false)
      })
      .catch((e: unknown) => {
        console.error('Failed to get geolocation:', e)
        setIsFailed(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, location.search])

  return { countryCodeIso3, isLoading, isFailed }
}
